/*

https://clipboardjs.com/ 

How To Use Template:
<ocm-copy-button value="COUPON2021" />

*/

const _showCopiedText = (element) => {
	element.querySelector(".js-clipboard__copy").style.display = "none";
	element.querySelector(".js-clipboard__copied").style.display = "block";
};

const _showCopyText = (element) => {
	element.querySelector(".js-clipboard__copy").style.display = "block";
	element.querySelector(".js-clipboard__copied").style.display = "none";
};

const _defineCustomElement = () => {
	class OcmCopyButton extends HTMLElement {
		connectedCallback() {
			const val = this.getAttribute("value");
			//Safari support: have to be in one string, otherwise safari won't work
			// prettier-ignore
			// eslint-disable-next-line prefer-template
			this.innerHTML = "<div class='c-clipboard'><input id='js-coupon-"+val+"' value='"+val+"' class='c-clipboard__input o-text-input'><button class='js-copy-btn c-clipboard__button o-btn c-btn--normal' data-clipboard-target='#js-coupon-"+val+"'><span class='js-clipboard__copy'>kopieren</span><span class='js-clipboard__copied'>kopiert ✓</span></button></div>"
		}
	}

	customElements.define("ocm-copy-button", OcmCopyButton);
};

const init = function () {
	_defineCustomElement();
	// eslint-disable-next-line no-undef
	const clipboard = new ClipboardJS(".js-copy-btn");

	clipboard.on("success", (e) => {
		_showCopiedText(e.trigger);
		e.clearSelection();

		setTimeout(() => {
			_showCopyText(e.trigger);
		}, 3000);
	});

	clipboard.on("error", (e) => {
		console.log(e, "error on clipboard");
	});
};

export { init };
